import { Injectable } from '@angular/core';
import {
  cloneDeepWith as _cloneDeepWith,
  find as _find,
  forEach as _forEach,
  get as _get,
  isArray as _isArray,
  isDate as _isDate,
  isEqual as _isEqual,
  isObject as _isObject,
  isPlainObject as _isPlainObject,
  mapKeys as _mapKeys,
  omit as _omit,
} from 'lodash';
import { getCreneauText, getRepasText } from '../constant/constant';
import { convertToHumanDate } from '../util/moment.utils';
import { CampConfigurationService } from './camp-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class HistoModificationService {

  private readonly HD_KIND_TYPECAMP = 'typeCamp';

  private readonly HD_KIND_CAMP = 'camp';
  private readonly HD_KIND_CAMP_817 = 'camp817';
  private readonly HD_KIND_CAMP_17_PLUS = 'camp17Plus';
  private readonly HD_KIND_CAMP_MODULE_INTERNATIONAL = 'campModuleInternational';
  private readonly HD_KIND_CAMP_STRUCTURE = 'campStructures';
  private readonly HD_KIND_CAMP_LIEU = 'campLieux';
  private readonly HD_KIND_CAMP_LIEU_PRINCIPAL = 'campLieuPrincipal';
  private readonly HD_KIND_CAMP_GRILLE_ACTIVITE = 'campGrilleActivites';
  private readonly HD_KIND_CAMP_JOURNEE_TYPE = 'campJourneeTypes';
  private readonly HD_KIND_CAMP_MENU = 'campMenus';
  private readonly HD_KIND_CAMP_NUMERO_UTILE = 'campNumeroUtiles';
  private readonly HD_KIND_CAMP_ADHERENT_STAFF = 'campAdherentStaffs';
  private readonly HD_KIND_CAMP_AVIS = 'campAvis';
  private readonly HD_KIND_CAMP_ADHERENT_PARTICIPANT = 'campAdherentParticipants';
  private readonly HD_KIND_CAMP_MODULE_INTERNATIONAL_TYPE_PROJET = 'campModuleInternational.campModuleInternationalTypesProjetInternational';
  private readonly HD_KIND_CAMP_MODULE_UNITE_ETRANGERE_TYPE_PROJET = 'campModuleUniteEtrangere.campModuleUniteEtrangereTypesProjetUniteEtrangere';
  private readonly HD_KIND_CAMP_17_PLUS_PISTE_ACTION = 'camp17Plus.camp17PlusPistesActions';
  private readonly HD_KIND_CAMP_17_PLUS_MOTIVATION = 'camp17Plus.camp17PlusMotivations';
  private readonly HD_KIND_CAMP_17_PLUS_PARTENAIRE = 'camp17Plus.camp17PlusPartenaires';
  private readonly HD_KIND_CAMP_MODULE_MARIN = 'campModuleMarin';
  private readonly HD_KIND_CAMP_MODULE_MARIN_ENCADRANT = 'campModuleMarin.campModuleMarinEncadrants';
  private readonly HD_KIND_CAMP_MODULE_MARIN_BATEAU = 'campModuleMarin.campModuleMarinBateaux';
  private readonly HD_KIND_CAMP_MODULE_MARIN_ENCADRANT_NAUTIQUE = 'campModuleMarin.campModuleMarinEncadrantsNautiques';
  private readonly HD_KIND_CAMP_MODULE_CHECKLIST = 'campModuleChecklist';
  private readonly HD_KIND_CAMP_MODULE_CHECKLIST_ITEMS = 'campModuleChecklist.campChecklistItems';

  private readonly HD_KIND_PROJET_ANNEE = 'projetAnnee';
  private readonly HD_KIND_PROJET_ANNEE_FC = 'projetAnneeFcTrimestre';
  private readonly HD_KIND_TYPEPROJETANNEE = 'typeProjetAnnee';
  private readonly HD_KIND_PROJET_ANNEE_ADHERENT_STAFF = 'projetAnneeAdherentStaffs';
  private readonly HD_KIND_PROJET_ANNEE_PERIODE = 'projetAnneePeriodes';
  private readonly HD_KIND_PROJET_ANNEE_LIEU = 'projetAnneeLieux';
  private readonly HD_KIND_PROJET_ANNEE_FC_TRIMESTRE = 'projetAnneeFcTrimestres';

// Gestion des référence
  private readonly HD_KIND_CAMP_GRILLE_ACTIVITE_STAFF_RESP = 'campGrilleActivite.staffResponsable';
  private readonly HD_KIND_CAMP_MODULE_INTERNATIONAL_ADHERENT_RESP = 'campModuleInternational.adherentResponsable';
  private readonly HD_KIND_CAMP_MODULE_UNITE_ETRANGERE_ADHERENT_RESP = 'campModuleUniteEtrangere.adherentResponsable';
  private readonly HD_KIND_CAMP_LIEU_TAM_REF_COMMUNE = 'campLieu.tamRefCommune';
  private readonly HD_KIND_CAMP_LIEU_TAM_REF_PAYS = 'campLieu.tamRefPays';
  private readonly HD_KIND_CAMP_MODULE_INTERNATIONAL_TAM_REF_PAYS = 'campModuleInternational.campModuleInternationalTamRefPays';
  private readonly HD_KIND_CAMP_MODULE_UNITE_ETRANGERE_TAM_REF_PAYS = 'campModuleUniteEtrangere.tamRefPays';
  private readonly HD_KIND_PROJET_ANNEE_LIEU_TAM_REF_COMMUNE = 'projetAnneeLieu.tamRefCommune';
  private readonly HD_KIND_PROJET_ANNEE_FC_RESPONSABLE = 'projetAnneeFcTrimestre.adherentResponsable';
  private readonly HD_KIND_PROJET_ANNEE_FC_DECLARANT = 'projetAnneeFcTrimestre.adherentDeclarant';
  private readonly HD_KIND_CAMP_MODULE_MARIN_ADHERENT_RESPONSABLE = 'campModuleMarin.adherentResponsable';

  private readonly typeDdcCamp = 'camp';
  private readonly typeDdcProjetAnnee = 'projetAnnee';

  private readonly SPECIAL_ITEM_KEYS: string[] = [
    this.HD_KIND_CAMP_AVIS,
    this.HD_KIND_CAMP_17_PLUS_PISTE_ACTION,
    this.HD_KIND_CAMP_17_PLUS_MOTIVATION,
    this.HD_KIND_CAMP_MODULE_MARIN_ENCADRANT_NAUTIQUE,
    this.HD_KIND_CAMP_17_PLUS_PARTENAIRE,
    this.HD_KIND_CAMP_MODULE_MARIN_ENCADRANT,
    this.HD_KIND_CAMP_MODULE_MARIN_BATEAU,
    this.HD_KIND_CAMP_MODULE_CHECKLIST_ITEMS
  ];
  private readonly SPECIAL_ITEM_KEYS_DICTIONARY: object = {
    'campAvis' : 'campAvis',
    'camp17Plus.camp17PlusPistesActions': 'camp17PlusPistesActions',
    'camp17Plus.camp17PlusMotivations': 'camp17PlusMotivations',
    'camp17Plus.camp17PlusPartenaires': 'camp17PlusPartenaires',
    'campModuleMarin.campModuleMarinEncadrantsNautiques': 'campModuleMarinEncadrantNautique',
    'campModuleMarin.campModuleMarinEncadrants': 'campModuleMarinEncadrant',
    'campModuleMarin.campModuleMarinBateaux': 'campModuleMarinBateau',
    'campModuleChecklist.campChecklistItems': 'campChecklistItem'
  };

  constructor(protected campConfigurationService: CampConfigurationService) {
  }

  /**
   * Calcule les changements apportés au camp
   */
  public computeCampHistorisableDataModifications(data, histoSource): object {
    return this._computeHistorisableDataModifications('', this._filterHistorisableDataFields(this.HD_KIND_CAMP, data), histoSource, '', false, this.typeDdcCamp);
  }

  /**
   * Calcule les changements apportés au projet d'annee
   */
  public computeProjetAnneeHistorisableDataModifications(data, histoSource): object {
    return this._computeHistorisableDataModifications('', this._filterHistorisableDataFields(this.HD_KIND_PROJET_ANNEE, data), histoSource, '', false, this.typeDdcProjetAnnee);

  }


  public prepareModificationInfosForDisplay(dynamicModuleCode: string, modificationInfos: any): any {
    if (!dynamicModuleCode) {
      return modificationInfos;
    }
    // Module dynamique
    // on doit rechercher texte question et texte réponse dans dictionnaire de traduction
    const transformedInfos = _cloneDeepWith(modificationInfos,
      (value, key, obj) => this._checkAndTransform(dynamicModuleCode, value, key, obj));
    return transformedInfos;
  }

  /*
   * Méthodes privées
   */

  private _checkAndTransform(dynamicModuleCode, value, key, obj) {
    if (!_isObject(value) && !_isArray(value)) {
      if (key === 'labelKey' && value.startsWith('surveyjsReponsesJson.')) {
        const tradKey = this._getDynamicModuleTradFieldKey(dynamicModuleCode, value.substr(21));
        return (tradKey) ? tradKey : value;
      } else if (key === 'labelKey' && value.startsWith('hd.surveyjsReponsesJson.')) {
        const tradKey = this._getDynamicModuleTradFieldKey(dynamicModuleCode, value.substr(24));
        return (tradKey) ? tradKey : value;
      } else if (key === 'oldVal' || key === 'newVal' ) {
        if (obj.labelKey && obj.labelKey.startsWith('surveyjsReponsesJson.')) {
          const tradKey = this._getDynamicModuleTradFieldKey(dynamicModuleCode,
            obj.labelKey.substr(21), `choice.${value}`);
          const tradVal = this.campConfigurationService.getLabelByKey(tradKey);
          return (tradVal) ? tradVal : value;
        } else if (obj.labelKey && obj.labelKey.startsWith('hd.surveyjsReponsesJson.')) {
          const tradKey = this._getDynamicModuleTradFieldKey(dynamicModuleCode,
            obj.labelKey.substr(24), `choice.${value}`);
          const tradVal = this.campConfigurationService.getLabelByKey(tradKey);
          return (tradVal) ? tradVal : value;
        }
      }
      return value;
    }
  }

  private _getDynamicModuleTradFieldKey(dynamicModuleCode: string, fieldKey: string, suffix: string = 'title'): string {
    return `survey.${dynamicModuleCode.toLowerCase()}.${fieldKey}.${suffix}`;
  }

  private _convertKebabToCamelCase(input: string): string {
    return input
      .split('-')
      .reduce(
        (res, word, i) =>
          i === 0
            ? word.toLowerCase()
            : `${res}${word.charAt(0).toUpperCase()}${word
              .substr(1)
              .toLowerCase()}`,
        ''
      );
  }

  /**
   * Calcul de la clé du libellé à afficher.
   * Les éléments non scalaires sont toujours préfixés par "hd." car ils représentent des sections dans l'historique des modifs.
   * Les éléments scalaires (string, number, date) ne sont pas préfixés car la résolution du libellé à l'affichage
   * utilisera le module de gestion des libellés en recherchant dans l'ordre avec le prefixe "hd." et "bdd."
   */
  private _getFieldKey(key: string, prefix: string = 'hd.', typeDdc: string): string {
    return `${prefix}${key || typeDdc}`;
  }

  /**
   * Calcul de la clé de comparaison des entités d'une liste afin de permettre une meilleure détection
   * des ajout/modification/suppression d'élément de la liste
   */
  private _getHistorisableDataItemKey(hdKind: string, item): string {
    if (hdKind === this.HD_KIND_CAMP_GRILLE_ACTIVITE) {
      return item.dateActivite + '-' + item.creneau;
    }
    if (hdKind === this.HD_KIND_CAMP_ADHERENT_STAFF && item.adherent) {
      const adherent = item.adherent;
      return adherent.numero;
    }
    if (hdKind === this.HD_KIND_CAMP_ADHERENT_PARTICIPANT && item.adherent) {
      const adherent = item.adherent;
      return adherent.numero;
    }
    if (hdKind === this.HD_KIND_CAMP_STRUCTURE && item.structure) {
      return item.structure.code.toString();
    }
    if (hdKind === this.HD_KIND_CAMP_JOURNEE_TYPE) {
      return item.heureDebut;
    }
    if (hdKind === this.HD_KIND_CAMP_MENU) {
      return item.dateMenu + '-' + item.repas;
    }
    if (hdKind === this.HD_KIND_CAMP_NUMERO_UTILE && item.numeroUtile) {
      return item.numeroUtile.id.toString();
    }
    if(hdKind === this.HD_KIND_CAMP_AVIS) {
      return item.typeAvis;
    }
    if (hdKind === this.HD_KIND_CAMP_GRILLE_ACTIVITE_STAFF_RESP && item.adherent) {
      const adherent = item.adherent;
      return adherent.numero;
    }
    if(hdKind === this.HD_KIND_CAMP_MODULE_INTERNATIONAL_ADHERENT_RESP || hdKind === this.HD_KIND_CAMP_MODULE_UNITE_ETRANGERE_ADHERENT_RESP) {
      return item.numero;
    }
    if(hdKind === this.HD_KIND_CAMP_17_PLUS_MOTIVATION) {
      return item.displayOrder;
    }

    if(hdKind === this.HD_KIND_PROJET_ANNEE_FC_RESPONSABLE || hdKind === this.HD_KIND_PROJET_ANNEE_FC_DECLARANT) {
      return item.numero;
    }

    if(hdKind === this.HD_KIND_CAMP_MODULE_INTERNATIONAL_TYPE_PROJET) {
      return item && item.typeProjetInternational ? item.typeProjetInternational.code : '';
    }

    if(hdKind === this.HD_KIND_CAMP_MODULE_UNITE_ETRANGERE_TYPE_PROJET) {
      return item && item.typeProjetUniteEtrangere ? item.typeProjetUniteEtrangere.code : '';
    }

    if(hdKind === this.HD_KIND_CAMP_MODULE_MARIN_ADHERENT_RESPONSABLE) {
      return item.numero;
    }

    return item ? (item.id || item.code) : '';
  }

  /**
   * Récupération du libellé à associer à l'entité créée/modifiée/supprimée
   */
  private _getHistorisableDataItemLabel(hdKind: string, item: any): string {
    if (hdKind === this.HD_KIND_CAMP_GRILLE_ACTIVITE) {
      return convertToHumanDate(item.dateActivite, false, true) + ' ' + getCreneauText(item.creneau);
    }
    if (
        (hdKind === this.HD_KIND_CAMP_ADHERENT_STAFF || hdKind === this.HD_KIND_PROJET_ANNEE_ADHERENT_STAFF) &&
        item.adherent
    ) {
      const adherent = item.adherent;
      return ((adherent.civilite) ? adherent.civilite.libelle + ' ' : '') + adherent.prenom + ' ' + adherent.nom + ' (' + adherent.numero + ')';
    }
    if (hdKind === this.HD_KIND_CAMP_ADHERENT_PARTICIPANT && item.adherent) {
      const adherent = item.adherent;
      return ((adherent.civilite) ? adherent.civilite.libelle + ' ' : '') + adherent.prenom + ' ' + adherent.nom + ' (' + adherent.numero + ')';
    }
    if (hdKind === this.HD_KIND_CAMP_STRUCTURE && item.structure) {
      return item.structure.libelle;
    }
    if(hdKind === this.HD_KIND_CAMP_LIEU_PRINCIPAL) {
      return item.libelle;
    }
    if (hdKind === this.HD_KIND_CAMP_JOURNEE_TYPE) {
      return item.heureDebut;
    }
    if (hdKind === this.HD_KIND_CAMP_MENU) {
      return convertToHumanDate(item.dateMenu, false, true) + ' ' + getRepasText(item.repas);
    }
    if (hdKind === this.HD_KIND_CAMP_NUMERO_UTILE && item.numeroUtile) {
      return item.numeroUtile.libelle;
    }
    if (hdKind === this.HD_KIND_CAMP_GRILLE_ACTIVITE_STAFF_RESP && item.adherent) {
      const adherent = item.adherent;
      return ((adherent.civilite) ? adherent.civilite.libelle + ' ' : '') + adherent.prenom + ' ' + adherent.nom;
    }
    if(hdKind === this.HD_KIND_CAMP_AVIS) {
      return item.typeAvis;
    }
    if(hdKind === this.HD_KIND_CAMP_MODULE_INTERNATIONAL_ADHERENT_RESP || hdKind === this.HD_KIND_CAMP_MODULE_UNITE_ETRANGERE_ADHERENT_RESP) {
      return ((item.civilite) ? item.civilite.libelle + ' ' : '') + item.prenom + ' ' + item.nom + ' (' + item.numero + ')';
    }

    if(
      hdKind === this.HD_KIND_CAMP_MODULE_INTERNATIONAL_TAM_REF_PAYS ||
      hdKind === this.HD_KIND_CAMP_MODULE_UNITE_ETRANGERE_TAM_REF_PAYS ||
      hdKind === this.HD_KIND_CAMP_LIEU_TAM_REF_PAYS
    ) {
      return  item ?  item.libelle : '';
    }

    if(hdKind === this.HD_KIND_CAMP_MODULE_INTERNATIONAL_TYPE_PROJET) {
      return item ? item.typeProjetInternational.libelle : '[NR]';
    }

    if(hdKind === this.HD_KIND_CAMP_MODULE_UNITE_ETRANGERE_TYPE_PROJET) {
      return item ? item.typeProjetUniteEtrangere.libelle : '[NR]';
    }

    if(hdKind === this.HD_KIND_CAMP_17_PLUS_PISTE_ACTION) {
      return item ? item.pisteAction.libelle : '[NR]';
    }

    if(hdKind === this.HD_KIND_PROJET_ANNEE_PERIODE) {
      return item.codePeriode;
    }

    if(hdKind === this.HD_KIND_PROJET_ANNEE_LIEU_TAM_REF_COMMUNE || hdKind === this.HD_KIND_CAMP_LIEU_TAM_REF_COMMUNE) {
      return `${item.libelle}(${item.codeInsee})`;
    }

    if(hdKind === this.HD_KIND_PROJET_ANNEE_FC_TRIMESTRE) {
      return item && item.trimestre ? item.trimestre.libelle : "Trimestre";
    }

    if(hdKind ===  this.HD_KIND_PROJET_ANNEE_FC_RESPONSABLE || hdKind === this.HD_KIND_PROJET_ANNEE_FC_DECLARANT) {
      return item ? ((item.civilite) ? item.civilite.libelle + ' ' : '') + item.prenom + ' ' + item.nom + ' (' + item.numero + ')' : 'item #' + this._getHistorisableDataItemKey(hdKind, item);
    }

    if(hdKind === this.HD_KIND_CAMP_MODULE_MARIN_ADHERENT_RESPONSABLE) {
      return ((item.civilite) ? item.civilite.libelle + ' ' : '') + item.prenom + ' ' + item.nom + ' (' + item.numero + ')';
    }

    if(hdKind === this.HD_KIND_CAMP_MODULE_MARIN_ENCADRANT_NAUTIQUE) {
      const adherent = item.adherent;
      return ((adherent.civilite) ? adherent.civilite.libelle + ' ' : '') + adherent.prenom + ' ' + adherent.nom + ' (' + adherent.numero + ')';
    }

    if(hdKind === this.HD_KIND_CAMP_MODULE_CHECKLIST_ITEMS) {
      const checklistItem = item.checklistItem;
      return checklistItem ? checklistItem.libelle : 'item #';
    }
    return item.libelle || 'item #' + this._getHistorisableDataItemKey(hdKind, item);
  }

  /**
   * Permet de filtrer la liste des champs à ignorer lors du calcul des modifications
   */
  private _filterHistorisableDataFields(hdKind: string, obj: any): any {
    // Part concerning 'Camp'
    if (hdKind === this.HD_KIND_CAMP) {
      return _omit(obj, [
        /* Fields static module */
        'id',
        '_droitsUtilisateurCourant',
        '_ddcCampHistoModuleDerniereModification',
        '_campAlertMessages',
        '_campValidationLevels',
        '_datesInterval',
        '_nombreMaximumParticipants',
        '_isCampEnfant',
        '_isCampPere',
        'codeGroupeCamp',
        'synthese',
        'tamRefExercice',
        'histoCreation',
        'histoDerniereModification',
        'campAdherentStaffsInformations',
        'campFichiers',
        /* Fields dynamic module */
        'camp',
        'module',
        'actif',
      ]);
    }
    if (hdKind === this.HD_KIND_CAMP_817) {
      return obj;
    }
    if(hdKind === this.HD_KIND_CAMP_17_PLUS) {
      return obj;
    }
    if(hdKind === this.HD_KIND_CAMP_LIEU_PRINCIPAL) {
      return obj;
    }
    if(hdKind === this.HD_KIND_CAMP_LIEU) {
      return _omit(obj,['id','tamRefCommuneCodePostale']);
    }
    if (hdKind === this.HD_KIND_CAMP_ADHERENT_STAFF) {
      return _omit(obj, ['id', 'adherent']);
    }
    if (hdKind === this.HD_KIND_CAMP_ADHERENT_PARTICIPANT) {
      return _omit(obj, ['id', 'adherent']);
    }
    if (hdKind === this.HD_KIND_CAMP_STRUCTURE) {
      return _omit(obj, ['id', 'structure']);
    }
    if (hdKind === this.HD_KIND_CAMP_GRILLE_ACTIVITE) {
      return obj;
    }
    if (hdKind === this.HD_KIND_CAMP_JOURNEE_TYPE) {
      return _omit(obj, ['id', 'heureDebut']);
    }
    if (hdKind === this.HD_KIND_CAMP_MENU) {
      return obj;
    }
    if (hdKind === this.HD_KIND_CAMP_NUMERO_UTILE) {
      return _omit(obj, ['id', 'numeroUtile']);
    }
    if(hdKind === this.HD_KIND_CAMP_AVIS) {
      return _omit(obj,['id','dateHeureDernierAvis', 'typeAvis']);
    }
    if (hdKind === this.HD_KIND_TYPECAMP) {
      return _omit(obj, ['id', 'code', 'modules']);
    }
    if(hdKind === this.HD_KIND_CAMP_MODULE_INTERNATIONAL) {
      return obj;
    }
    if(hdKind === this.HD_KIND_CAMP_MODULE_INTERNATIONAL_TYPE_PROJET) {
      return _omit(obj, ['id','typeProjetInternational']);
    }
    if(hdKind === this.HD_KIND_CAMP_MODULE_INTERNATIONAL_TAM_REF_PAYS) {
      return _omit(obj, ['id','typeProjetInternational']);
    }
    if(hdKind === this.HD_KIND_CAMP_MODULE_UNITE_ETRANGERE_TYPE_PROJET) {
      return _omit(obj, ['id','typeProjetUniteEtrangere']);
    }
    if(hdKind === this.HD_KIND_CAMP_17_PLUS_PISTE_ACTION) {
      return _omit(obj,['id', 'pisteAction']);
    }
    if(hdKind === this.HD_KIND_CAMP_17_PLUS_PARTENAIRE) {
      return _omit(obj, ['id']);
    }
    if(hdKind === this.HD_KIND_CAMP_17_PLUS_MOTIVATION) {
      return _omit(obj, ['id']);
    }
    if(hdKind === this.HD_KIND_CAMP_MODULE_MARIN) {
      return obj;
    }
    if(hdKind === this.HD_KIND_CAMP_MODULE_MARIN_ENCADRANT) {
      return _omit(obj,['id']);
    }
    if(hdKind === this.HD_KIND_CAMP_MODULE_MARIN_BATEAU) {
      return _omit(obj,['id']);
    }
    if(hdKind === this.HD_KIND_CAMP_MODULE_MARIN_ENCADRANT_NAUTIQUE) {
      return _omit(obj, ['id', 'adherent']);
    }
    if(hdKind === this.HD_KIND_CAMP_MODULE_CHECKLIST_ITEMS) {
      return _omit(obj, ['id', 'checklistItem']);
    }

    // Part concerning 'Projet d'annee'
    if(hdKind === this.HD_KIND_PROJET_ANNEE) {
      return _omit(obj, [
        /* Fields static module */
        'id',
        '_droitsUtilisateurCourant',
        '_ddcProjetAnneeHistoModuleDerniereModification',
        'tamRefExercice',
        'structureProjetAnnee',
        'idTam',
        'commentaireDeclarationTam',
        'commentaireModificationDeclarationTam',
        'statutDeclarationTam',
        'errorsDeclarationTam',
        'dateHeureDeclarationTam',
        'adherentDeclarationTam',
        'dateModificationDeclarationTam',
        'adherentValidationDeclarationTam',
        'projetAnneeFichiers',
        'projetAnneeAdherentStaffsInformations',
        'histoCreation',
        'histoDerniereModification',
        'trimestresDatesIntervals',
      ]);
    }
    if(hdKind === this.HD_KIND_PROJET_ANNEE_FC) {

    }
    if(hdKind === this.HD_KIND_PROJET_ANNEE_ADHERENT_STAFF) {
      return _omit(obj, ['id', 'adherent']);
    }
    if(hdKind === this.HD_KIND_PROJET_ANNEE_PERIODE) {
      return _omit(obj, ['id', 'typePeriode']);
    }
    if(hdKind === this.HD_KIND_PROJET_ANNEE_LIEU) {
      return _omit(obj,['tamRefCommuneCodePostale']);
    }
    if(hdKind === this.HD_KIND_PROJET_ANNEE_FC_TRIMESTRE) {
      return _omit(obj, [
        'trimestre',
        'idTam',
        'commentaireDeclarationTam',
        'commentaireModificationDeclarationTam',
        'statutDeclarationTam',
        'errorsDeclarationTam',
        'dateHeureDeclarationTam',
        'adherentDeclarationTam',
        'dateModificationDeclarationTam',
        'adherentValidationDeclarationTam'
      ]);
    }
    if(hdKind === this.HD_KIND_TYPEPROJETANNEE) {
      return _omit(obj, ['id', 'code', 'modules']);
    }
    if (hdKind) {
      console.warn('Missing filtrering for', hdKind);
    }
    return obj;
  }

  private _isReference(currentLabelKeyPath: string): boolean {
    return  (
      currentLabelKeyPath === this.HD_KIND_CAMP_GRILLE_ACTIVITE_STAFF_RESP ||
      currentLabelKeyPath === this.HD_KIND_CAMP_LIEU_PRINCIPAL ||
      currentLabelKeyPath === this.HD_KIND_CAMP_LIEU_TAM_REF_COMMUNE ||
      currentLabelKeyPath === this.HD_KIND_PROJET_ANNEE_LIEU_TAM_REF_COMMUNE ||
      currentLabelKeyPath === this.HD_KIND_CAMP_LIEU_TAM_REF_PAYS ||
      currentLabelKeyPath === this.HD_KIND_PROJET_ANNEE_FC_RESPONSABLE ||
      currentLabelKeyPath === this.HD_KIND_PROJET_ANNEE_FC_DECLARANT ||
      currentLabelKeyPath === this.HD_KIND_CAMP_MODULE_INTERNATIONAL_TAM_REF_PAYS ||
      currentLabelKeyPath === this.HD_KIND_CAMP_MODULE_UNITE_ETRANGERE_TAM_REF_PAYS ||
      currentLabelKeyPath === this.HD_KIND_CAMP_MODULE_INTERNATIONAL_ADHERENT_RESP ||
      currentLabelKeyPath === this.HD_KIND_CAMP_MODULE_UNITE_ETRANGERE_ADHERENT_RESP ||
      currentLabelKeyPath === this.HD_KIND_CAMP_MODULE_MARIN_ADHERENT_RESPONSABLE
    );
  }

  private _computeHistorisableDataModifications(currentItemPath: string, data, histoSource, currentLabelKeyPath: string,
                                                isForArray: boolean = false, typeDdc: string) {

    if (data && (!!data._isAMomentObject || _isDate(data))) {
      // Données Moment (datetime)
      const oldVal = convertToHumanDate(_get(histoSource, currentItemPath));
      const newVal = convertToHumanDate(data);
      const labelKey = this._getFieldKey(currentLabelKeyPath, '', typeDdc);
      return (newVal !== oldVal)
        ? {labelKey: ((labelKey.indexOf('.') === -1) ? typeDdc+'.' : '') + labelKey, oldVal, newVal}
        : null;

    } else if (_isPlainObject(data)) {
      // Objet
      if (this._isReference(currentLabelKeyPath)) {
        // Référence à un objet (link)
        return this._computeHistorisableDataModificationsForReference(currentLabelKeyPath, data, _get(histoSource, currentItemPath));
      } else {
        // Objet
        const ret = [];
        _forEach(this._filterHistorisableDataFields(currentItemPath, data),
          (v, k) => {
            const childItemPath = (currentItemPath !== '' ? currentItemPath + '.' : '') + k;
            const childLabelKeyPath = (currentLabelKeyPath !== '' ? currentLabelKeyPath + '.' : '') + k;
            const val = this._computeHistorisableDataModifications(childItemPath, v, histoSource, childLabelKeyPath, false, typeDdc);
            if (val) {
              ret.push(val);
            }
          });
        return (ret.length > 0) ? (isForArray) ? ret : {labelKey: this._getFieldKey(currentLabelKeyPath, 'hd.', typeDdc), hdType: 'obj', changes: ret} : null;
      }
    } else if (_isArray(data)) {
      // Traitement des tableaux (liste d'item)
      const changes = this._computeHistorisableDataModificationsForArray(currentItemPath, data, _get(histoSource, currentItemPath), typeDdc);
      return (changes) ? {labelKey: this._getFieldKey(currentLabelKeyPath, 'hd.', typeDdc), hdType: 'list', changes} : null;

    } else {
      // Données scalaire
      const oldVal = _get(histoSource, currentItemPath);
      const labelKey = this._getFieldKey(currentLabelKeyPath, '', typeDdc);
      return (!_isEqual(data, oldVal))
        ? {labelKey: ((labelKey.indexOf('.') === -1) ? typeDdc+'.' : '') + labelKey, oldVal, newVal: data}
        : null;
    }
  }

  private _getSpecialArrayItemKey(arrayItemKey: string) {
    return this.SPECIAL_ITEM_KEYS_DICTIONARY[arrayItemKey];
  }

  /**
   * Calcule les chamgements apportés à une liste (ajout, modification et suppression)
   * TODO gérer les liste non d'objets tel que string[] (si besoin)
   */
  private _computeHistorisableDataModificationsForArray(arrayItemKey: string, items, oldItems, typeDdc: string) {
    const ret = [];

    // On supprime le "s" ou le "x" du pluriel afin d'avoir un labelKey compatible avec le module
    // de gestion dynamique des libellés.
    // donot change the labelKey in some case, example campAvis (singular and plural are the same)
    const arrayLabelKey = this.SPECIAL_ITEM_KEYS.includes(arrayItemKey) ? this._getSpecialArrayItemKey(arrayItemKey)
      : arrayItemKey.endsWith('s')
        ? arrayItemKey.substr(0, arrayItemKey.length - 1)
      : arrayItemKey.endsWith('x')
        ? arrayItemKey.substr(0, arrayItemKey.length - 1)
      : arrayItemKey;

    // Recherche des nouveaux ou changement
    _forEach(items,
      (newItem) => {
        const itemKey = this._getHistorisableDataItemKey(arrayItemKey, newItem);
        // Cet item existait-il déjà => modification
        const oldItem = _find(oldItems,
          (item) => {
            return this._getHistorisableDataItemKey(arrayItemKey, item) === itemKey;
          });
        if (oldItem) {
          // Modification ?
          const val = this._computeHistorisableDataModifications('', this._filterHistorisableDataFields(arrayItemKey, newItem), oldItem, arrayLabelKey, true, typeDdc);
          if (val) {
            // Il y a des changements
            ret.push({hdActionType: 'changed', itemLabel: this._getHistorisableDataItemLabel(arrayItemKey, newItem), changes: val});
          }
        } else {
          // Nouveau
          const newValObj = _mapKeys(this._filterHistorisableDataFields(arrayItemKey, newItem),
            (v, k) => {
              return (arrayLabelKey + '.' + k);
            });
          ret.push({
            hdActionType: 'added',
            itemLabel: this._getHistorisableDataItemLabel(arrayItemKey, newItem),
            newVal: newValObj
          });
        }
      });

    // Détection suppression
    _forEach(oldItems,
      (oldItem) => {
        const itemKey = this._getHistorisableDataItemKey(arrayItemKey, oldItem);
        const newItem = _find(items,
          (item) => {
            return this._getHistorisableDataItemKey(arrayItemKey, item) === itemKey;
          });
        if (newItem == null) {
          // Supprimé
          ret.push({hdActionType: 'removed', itemLabel: this._getHistorisableDataItemLabel(arrayItemKey, oldItem)});
        }
      });

    return (ret.length > 0) ? ret : null;
  }

  /**
   * Calcule le chamgement de valeur référencées en tant que réponse
   */
  private _computeHistorisableDataModificationsForReference(currentLabelKeyPath: string, newItem, oldItem) {

    const newItemKey = (newItem === null) ? null : this._getHistorisableDataItemKey(currentLabelKeyPath, newItem);
    const oldItemKey = (oldItem === null) ? null : this._getHistorisableDataItemKey(currentLabelKeyPath, oldItem);

    return (!_isEqual(newItemKey, oldItemKey))
      ? {
        labelKey: currentLabelKeyPath,
        oldVal: (oldItemKey === null) ? null : this._getHistorisableDataItemLabel(currentLabelKeyPath, oldItem),
        newVal: (newItemKey === null) ? null : this._getHistorisableDataItemLabel(currentLabelKeyPath, newItem)
      }
      : null;
  }
}
